import { useCallback, useEffect, useState } from 'react'
import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import { SCORE_TOOLTIP_FORMAT } from './Slider.const'
import useStyles from './Slider.styled'

export const useSlider = ({ onClick, pending, justify, shadow, answers }) => {
	const settingsMin = useQuestionSettingsField('min')
	const min = settingsMin || 0
	const settingMax = useQuestionSettingsField('max')
	const max = _.max([settingMax ?? min + 1, min])
	const settingsDefaultValue = useQuestionSettingsField('default')
	const defaultValue = Number(_.get(answers, [0, 'answer']) ?? settingsDefaultValue ?? min)
	const showTooltip = useQuestionSettingsField('score_tooltip', true)
	const tooltipFormat = useQuestionSettingsField('score_tooltip_format')
	const labels = useQuestionSettingsField('labels')
	const classes = useStyles()
	const [value, setValue] = useState(defaultValue)

	const handleChange = useCallback((event, newValue) => {
		setValue(newValue)
	}, [])

	const handleSubmit = useCallback(() => {
		onClick({ answer: value })
	}, [onClick, value])

	const valueLabelFormat = useCallback(
		currValue => {
			switch (tooltipFormat) {
				case SCORE_TOOLTIP_FORMAT.ACTUAL:
					return currValue
				case SCORE_TOOLTIP_FORMAT.PERCENT:
				default: {
					const percent = ((currValue - min) * 100) / (max - min)

					return `${Math.round(percent)}%`
				}
			}
		},
		[max, min, tooltipFormat],
	)

	useEffect(() => {
		if (value !== defaultValue && _.inRange(defaultValue, min - 0.1, max + 0.1)) {
			setValue(defaultValue)
		} else if (!_.inRange(value, min - 0.1, max + 0.1)) {
			setValue(min)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [min, max, defaultValue])

	useEffect(() => {
		const handleKeyUp = ({ key }) => {
			if (key === 'Enter') {
				handleSubmit()
			}
		}

		document.addEventListener('keyup', handleKeyUp)
		return () => {
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, [handleSubmit])

	return [
		{
			classes,
			min,
			max,
			value,
			step: 1,
			labels,
			pending,
			justify,
			shadow,
			valueLabelDisplay: showTooltip ? 'auto' : 'off',
			withLabels: _.some(labels, ({ text }) => text?.trim()),
		},
		{ handleChange, handleSubmit, valueLabelFormat },
	]
}
